<template>
  <div class="modal-success-luckydraw">
    <a-modal
      v-model="showModal"
      crm_at="modal_success_luckydraw"
      class="modal-SuccessLuckyDraw"
      centered
      :footer="null"
      :after-close="closeButton"
    >
      <div :class="currentLocale">
        <div class="row">
          <div class="col-12 d-flex justify-center mt-3">
            <gif-player
              :src="checkGreen"
              width="120"
              height="120"
              autoplay="true"
              :loop="false"
              muted
            ></gif-player>
          </div>
          <div class="col-12 text-center title my-3">
            {{ lbl.lucky_draw.congrats_message }}
          </div>
          <div class="col-12">
            <div class="box-campaign p-3 mx-2 d-flex">
              <div class="w-img-luckydraw">
                <a-avatar
                  slot="avatar"
                  crm_at="img_luckydraw"
                  shape="square"
                  :size="70"
                  :src="imageUrl"
                />
              </div>
              <div class="px-2 title-luckydraw">{{ title }}</div>
            </div>
          </div>
          <div class="col-12 text-center">
            <div class="my-3 point-luckydraw">
              <span v-if="pointPerUnit <= 0">{{ lbl.main.free }}</span>
              <span v-else
                >{{ lbl.lucky_draw.by_spending }} {{ pointPerUnit }}
                {{ lbl.main.points }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import Locale from '@/helper/Locale.js'
import CommonMixin from '@/mixin/CommonMixin'
import ResponsiveMixin from '@/mixin/ResponsiveMixin'

export default {
  mixins: [CommonMixin, ResponsiveMixin],
  props: {
    show: Boolean,
    data: Object,
  },
  data() {
    return {
      currentLocale: Locale.getLocale(),
      showModal: false,
      title: '',
      imageUrl: '',
      pointPerUnit: 0,
      checkGreen: '',
    }
  },
  watch: {
    show(newVal) {
      if (newVal === true) {
        this.initModal(newVal)
      }
    },
  },
  methods: {
    initModal(isShow) {
      this.checkGreen = require('@/assets/images/luckydraw/check-green-mp4.mp4')
      this.showModal = isShow
      this.title = this.data ? this.data.title : ''
      this.imageUrl = this.data ? this.data.img : ''
      this.pointPerUnit = this.data ? this.data.pointperunit : 0
    },
    closeButton() {
      this.showModal = false
      this.$emit('successLuckyDraw', true)
    },
  },
}
</script>

<style lang="scss">
@import '@/style/_mixin.scss';
.modal-SuccessLuckyDraw {
  .gif-player .OOKpgQoKM {
    display: none;
  }

  .gif-player .YnXDvQvpM {
    background: initial;
  }

  .gif-player .vmDOAnrkZ {
    display: none;
  }

  .ant-modal-close {
    top: 10px;
    right: 10px;
  }

  .title {
    font-size: 16px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: 0.5px;
    text-align: center;
    color: $color-modal-title;
  }

  .box-campaign {
    border-radius: 6px;
    border: solid 1px $color-border-d8;
    background-color: $color-gray-fc;
  }

  .w-img-luckydraw {
    width: 70px;
    height: 70px;
    border-radius: 4px;
    border: solid 1px $color-line;
  }

  .title-luckydraw {
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: $color-text-dark;
  }

  .point-luckydraw {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.57;
    letter-spacing: 0.15px;
    text-align: center;
    color: $color-modal-desc;
  }
  .box-icon-success {
    background-color: $color-green-7e;
    color: $white;
    width: 120px;
    height: 120px;
    justify-content: center;
    border-radius: 100px;
  }

  .justify-center {
    justify-content: center;
  }
}
</style>